"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

var _combineStreams = _interopRequireDefault(require("../util/combine-streams"));

var _constants = require("../util/constants");

var _apiKeys = _interopRequireDefault(require("./api-keys"));

var _collaborators = _interopRequireDefault(require("./collaborators"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Gateways = /*#__PURE__*/function () {
  function Gateways(api, _ref) {
    var defaultUserId = _ref.defaultUserId,
        stackConfig = _ref.stackConfig;
    (0, _classCallCheck2["default"])(this, Gateways);
    this._api = api;
    this._defaultUserId = defaultUserId;
    this._stackConfig = stackConfig;
    this.ApiKeys = new _apiKeys["default"](api.GatewayAccess, {
      parentRoutes: {
        get: 'gateway_ids.gateway_id',
        list: 'gateway_ids.gateway_id',
        create: 'gateway_ids.gateway_id',
        update: 'gateway_ids.gateway_id'
      }
    });
    this.Collaborators = new _collaborators["default"](api.GatewayAccess, {
      parentRoutes: {
        get: 'gateway_ids.gateway_id',
        list: 'gateway_ids.gateway_id',
        set: 'gateway_ids.gateway_id'
      }
    });
  }

  (0, _createClass2["default"])(Gateways, [{
    key: "_emitDefaults",
    value: function _emitDefaults(paths, gateway) {
      // Handle zero coordinates that are swallowed by the grpc-gateway for
      // gateway antennas.
      if (paths.includes('antennas') && Boolean(gateway.antennas)) {
        var antennas = gateway.antennas;

        var _iterator = _createForOfIteratorHelper(antennas),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var antenna = _step.value;

            if (antenna !== null && (0, _typeof2["default"])(antenna) === 'object' && antenna.location !== null && (0, _typeof2["default"])(antenna.location) === 'object') {
              if (!('altitude' in antenna.location)) {
                antenna.location.altitude = 0;
              }

              if (!('longitude' in antenna.location)) {
                antenna.location.longitude = 0;
              }

              if (!('latitude' in antenna.location)) {
                antenna.location.latitude = 0;
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } // Handle missing boolean values.


      if (paths.includes('location_public') && !Boolean(gateway.location_public)) {
        gateway.location_public = false;
      }

      if (paths.includes('status_public') && !Boolean(gateway.status_public)) {
        gateway.status_public = false;
      }

      if (paths.includes('auto_update') && !Boolean(gateway.auto_update)) {
        gateway.auto_update = false;
      }

      if (paths.includes('schedule_downlink_late') && !Boolean(gateway.schedule_downlink_late)) {
        gateway.schedule_downlink_late = false;
      }

      if (paths.includes('require_authenticated_connection') && !Boolean(gateway.require_authenticated_connection)) {
        gateway.require_authenticated_connection = false;
      }

      if (paths.includes('update_location_from_status') && !Boolean(gateway.update_location_from_status)) {
        gateway.update_location_from_status = false;
      }

      if (paths.includes('disable_packet_broker_forwarding') && !Boolean(gateway.disable_packet_broker_forwarding)) {
        gateway.disable_packet_broker_forwarding = false;
      }

      return gateway;
    } // Retrieval.

  }, {
    key: "getAll",
    value: function () {
      var _getAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(params, selector) {
        var response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.GatewayRegistry.List(undefined, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 2:
                response = _context.sent;
                return _context.abrupt("return", _marshaler["default"].unwrapGateways(response));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAll(_x, _x2) {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "getById",
    value: function () {
      var _getById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(id, selector) {
        var fieldMask, response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context2.next = 3;
                return this._api.GatewayRegistry.Get({
                  routeParams: {
                    'gateway_ids.gateway_id': id
                  }
                }, fieldMask);

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", this._emitDefaults(fieldMask.field_mask.paths, _marshaler["default"].unwrapGateway(response)));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getById(_x3, _x4) {
        return _getById.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "search",
    value: function () {
      var _search = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(params, selector) {
        var response;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._api.EntityRegistrySearch.SearchGateways(undefined, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 2:
                response = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].unwrapGateways(response));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function search(_x5, _x6) {
        return _search.apply(this, arguments);
      }

      return search;
    }() // Update.

  }, {
    key: "updateById",
    value: function () {
      var _updateById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(id, patch) {
        var mask,
            response,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                mask = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : _marshaler["default"].fieldMaskFromPatch(patch, this._api.GatewayRegistry.UpdateAllowedFieldMaskPaths);
                _context4.next = 3;
                return this._api.GatewayRegistry.Update({
                  routeParams: {
                    'gateway.ids.gateway_id': id
                  }
                }, {
                  gateway: patch,
                  field_mask: _marshaler["default"].fieldMask(mask)
                });

              case 3:
                response = _context4.sent;
                return _context4.abrupt("return", this._emitDefaults(mask, _marshaler["default"].unwrapGateway(response)));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateById(_x7, _x8) {
        return _updateById.apply(this, arguments);
      }

      return updateById;
    }() // Creation.

  }, {
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var ownerId,
            gateway,
            isUserOwner,
            routeParams,
            response,
            _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                ownerId = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : this._defaultUserId;
                gateway = _args5.length > 1 ? _args5[1] : undefined;
                isUserOwner = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : true;
                routeParams = isUserOwner ? {
                  'collaborator.user_ids.user_id': ownerId
                } : {
                  'collaborator.organization_ids.organization_id': ownerId
                };
                _context5.next = 6;
                return this._api.GatewayRegistry.Create({
                  routeParams: routeParams
                }, {
                  gateway: gateway
                });

              case 6:
                response = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].unwrapGateway(response));

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function create() {
        return _create.apply(this, arguments);
      }

      return create;
    }() // Deletion.

  }, {
    key: "deleteById",
    value: function () {
      var _deleteById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(id) {
        var response;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._api.GatewayRegistry.Delete({
                  routeParams: {
                    gateway_id: id
                  }
                });

              case 2:
                response = _context6.sent;
                return _context6.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function deleteById(_x9) {
        return _deleteById.apply(this, arguments);
      }

      return deleteById;
    }()
  }, {
    key: "purgeById",
    value: function () {
      var _purgeById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(id) {
        var response;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._api.GatewayRegistry.Purge({
                  routeParams: {
                    gateway_id: id
                  }
                });

              case 2:
                response = _context7.sent;
                return _context7.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function purgeById(_x10) {
        return _purgeById.apply(this, arguments);
      }

      return purgeById;
    }() // Miscellaneous.

  }, {
    key: "getStatisticsById",
    value: function () {
      var _getStatisticsById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(id) {
        var response;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._api.Gs.GetGatewayConnectionStats({
                  routeParams: {
                    gateway_id: id
                  }
                });

              case 2:
                response = _context8.sent;
                return _context8.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getStatisticsById(_x11) {
        return _getStatisticsById.apply(this, arguments);
      }

      return getStatisticsById;
    }()
  }, {
    key: "getRightsById",
    value: function () {
      var _getRightsById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(gatewayId) {
        var result;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this._api.GatewayAccess.ListRights({
                  routeParams: {
                    gateway_id: gatewayId
                  }
                });

              case 2:
                result = _context9.sent;
                return _context9.abrupt("return", _marshaler["default"].unwrapRights(result));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getRightsById(_x12) {
        return _getRightsById.apply(this, arguments);
      }

      return getRightsById;
    }() // Events Stream

  }, {
    key: "openStream",
    value: function () {
      var _openStream = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(identifiers, tail, after) {
        var _this = this;

        var payload, distinctComponents, streams;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                payload = {
                  identifiers: identifiers.map(function (id) {
                    return {
                      gateway_ids: {
                        gateway_id: id
                      }
                    };
                  }),
                  tail: tail,
                  after: after
                }; // Event streams can come from multiple stack components. It is necessary to
                // check for stack components on different hosts and open distinct stream
                // connections for any distinct host if need be.

                distinctComponents = this._stackConfig.getComponentsWithDistinctBaseUrls([_constants.STACK_COMPONENTS_MAP.is, _constants.STACK_COMPONENTS_MAP.gs]);
                streams = distinctComponents.map(function (component) {
                  return _this._api.Events.Stream({
                    component: component
                  }, payload);
                }); // Combine all stream sources to one subscription generator.

                return _context10.abrupt("return", (0, _combineStreams["default"])(streams));

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function openStream(_x13, _x14, _x15) {
        return _openStream.apply(this, arguments);
      }

      return openStream;
    }() // Gateway Configuration Server.

  }, {
    key: "getGlobalConf",
    value: function () {
      var _getGlobalConf = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(gatewayId) {
        var endpoint, response;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                // Endpoint hardcoded because it is not part of the gRPC API.
                // Refactor implementation once the following issue is resolved:
                // https://github.com/TheThingsNetwork/lorawan-stack/issues/3280
                endpoint = "/gcs/gateways/".concat(gatewayId, "/semtechudp/global_conf.json");
                _context11.next = 3;
                return this._api._connector.handleRequest('get', endpoint, 'gcs', false);

              case 3:
                response = _context11.sent;
                return _context11.abrupt("return", _marshaler["default"].payloadSingleResponse(response.data));

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getGlobalConf(_x16) {
        return _getGlobalConf.apply(this, arguments);
      }

      return getGlobalConf;
    }()
  }]);
  return Gateways;
}();

var _default = Gateways;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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